import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { marked } from 'marked';
import type { Post, PostMeta } from '../models/post.model';
import postsData from '../../../../../../public/data/posts.json';

/** Entry shape stored in `public/data/posts.json` (generated by scripts/generate-posts-index.mjs). */
type PostBundleEntry = PostMeta & { rawContent: string };

@Injectable({ providedIn: 'root' })
export class BlogService {
  // The bundle is statically imported, so it is inlined into the build and is
  // available identically during prerender, SSR, and in the browser — no HTTP
  // request and no TransferState round-trip. Markdown is rendered once here and
  // the result is reused for the lifetime of the app.
  private readonly posts: Post[] = (postsData as unknown as PostBundleEntry[]).map(renderPost);

  /** Returns all published posts (newest first), each with HTML content pre-rendered. */
  getPostList(): Observable<Post[]> {
    return of(this.posts);
  }

  /** True when at least one published post is available. Synchronous (SSR/prerender-safe). */
  hasPosts(): boolean {
    return this.posts.length > 0;
  }
}

function renderPost(entry: PostBundleEntry): Post {
  // Content is trusted, version-controlled Markdown from this repo's /posts
  // folder. Angular's [innerHTML] sanitizer provides baseline protection; add
  // DOMPurify if the content source ever becomes untrusted.
  const content = marked.parse(entry.rawContent, { async: false }) as string;
  return { ...entry, content };
}
